// extracted by mini-css-extract-plugin
module.exports = {"qaContainer":"styles_qaContainer__s5883"};